module.exports = __webpack_public_path__ + "static/img/pic_coop01@2x.3321c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/aboutUs/pic_coop01@2x.png
// module id = M882
// module chunks = 0